import React from "react";

const RenderIf = ({ condition = true, children = null }) => {
  return condition && children;
};

export default RenderIf;
